import SavingsStartupMarchLarge from 'assets/images/savings-account/savings-account-promo-march-desktop.png'
import SavingsStartupMarchSmall from 'assets/images/savings-account/savings-account-promo-march-mobile.png'
import SavingsStartupMarchMedium from 'assets/images/savings-account/savings-account-promo-march-tablet.png'

type GetSavingsStartupMarchImageArgs = {
  isMobile: boolean
  isMobileOrTablet: boolean
}

export const getSavingsStartupMarchImage = ({
  isMobile,
  isMobileOrTablet,
}: GetSavingsStartupMarchImageArgs) => {
  if (isMobile) {
    return [SavingsStartupMarchSmall]
  }

  if (isMobileOrTablet) {
    return [SavingsStartupMarchMedium]
  }

  return [SavingsStartupMarchLarge]
}
